import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e9e1ee3")

_pushScopeId("data-v-0e9e1ee3")
const _hoisted_1 = {
  class: "container regular-container",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "accounting-document-title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "accounting-body" }
const _hoisted_8 = { class: "row mx-auto" }
const _hoisted_9 = { class: "col-12 col-lg-5 mx-lg-auto" }
const _hoisted_10 = {
  class: "accounting-inline-title-ex w-100",
  style: {"line-height":"20px"}
}
const _hoisted_11 = { class: "accounting-inline-value-ex w-100" }
const _hoisted_12 = { class: "row mx-auto mt-12" }
const _hoisted_13 = { class: "col-12 col-lg-5 mx-lg-auto" }
const _hoisted_14 = {
  class: "accounting-inline-title-ex w-100",
  style: {"line-height":"20px"}
}
const _hoisted_15 = { class: "accounting-inline-value-ex w-100" }
const _hoisted_16 = { class: "desktop-grid" }
const _hoisted_17 = { class: "w100" }
const _hoisted_18 = { class: "desktop-table-text-setting" }
const _hoisted_19 = { class: "desktop-table-text-setting" }
const _hoisted_20 = { class: "desktop-table-text-setting" }
const _hoisted_21 = { class: "desktop-table-text-setting" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "desktop-table-text-setting" }
const _hoisted_24 = /*#__PURE__*/_createVNode("td", { class: "desktop-table-text-setting" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("td", { class: "desktop-table-text-setting" }, null, -1)
const _hoisted_26 = { class: "desktop-table-text-setting" }
const _hoisted_27 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, null, -1)
const _hoisted_28 = { class: "mobile-grid" }
const _hoisted_29 = { class: "w100" }
const _hoisted_30 = { class: "table-text-setting" }
const _hoisted_31 = { class: "table-text-setting" }
const _hoisted_32 = { class: "table-text-setting" }
const _hoisted_33 = { class: "table-text-setting" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "table-text-setting" }
const _hoisted_36 = /*#__PURE__*/_createVNode("td", { class: "table-text-setting" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("td", { class: "table-text-setting" }, null, -1)
const _hoisted_38 = { class: "table-text-setting" }
const _hoisted_39 = { class: "accounting-total-form" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "price-delimiter w-100 mt-20" }, null, -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = {
  class: "price-row w-100",
  style: {"margin":"6px 0 4px"}
}
const _hoisted_44 = { class: "price-title" }
const _hoisted_45 = { class: "price-value" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "price-delimiter w-100" }, null, -1)
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "price-row w-100 mt-12 d-block" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-7 my-auto" }
const _hoisted_52 = { class: "price-title" }
const _hoisted_53 = { class: "col-5" }
const _hoisted_54 = { class: "price-value d-flex justify-content-end" }
const _hoisted_55 = { class: "price-row  w-100" }
const _hoisted_56 = { class: "price-title" }
const _hoisted_57 = { class: "price-value" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "price-total-delimiter w-100" }, null, -1)
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-12" }
const _hoisted_61 = {
  class: "price-row  w-100",
  style: {"margin":"12px 0"}
}
const _hoisted_62 = { class: "price-title" }
const _hoisted_63 = { class: "price-total-value" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "price-total-delimiter w-100" }, null, -1)
const _hoisted_65 = { class: "invoice-total-amount-block" }
const _hoisted_66 = { class: "d-flex justify-content-between mt-28 col-10 col-lg-4 mx-auto" }
const _hoisted_67 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  disabled: "",
  class: "accounting-circle-button btn-blue"
}, " Share ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            ($setup.invoice.type == 2)
              ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('accounting.creditInvoice')), 1))
              : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('accounting.invoice')), 1)),
            _createTextVNode(" #" + _toDisplayString($setup.invoice.documentNumber) + " of ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'order', params: { id: $setup.invoice.orderId } },
              class: "text-link"
            }, {
              default: _withId(() => [
                _createTextVNode(" Order #" + _toDisplayString($setup.invoice.orderNumber), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('accounting.to')) + ":", 1),
                _createVNode("div", _hoisted_11, _toDisplayString($setup.invoice.recipientName), 1)
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('accounting.for')) + ":", 1),
                _createVNode("div", _hoisted_15, _toDisplayString($setup.invoice.for), 1)
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("table", _hoisted_17, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.itemDescription')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.qty')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.unit')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                    ])
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.invoice.products, (product, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", _hoisted_18, _toDisplayString(product.name) + "," + _toDisplayString(product.unitName), 1),
                      _createVNode("td", _hoisted_19, _toDisplayString(product.quantity), 1),
                      _createVNode("td", _hoisted_20, _toDisplayString(_ctx.formatAmount(product.pricePerUnit)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1),
                      _createVNode("td", _hoisted_21, _toDisplayString(_ctx.formatAmount(product.total)) + " " + _toDisplayString($setup.getCurrencySymbol(product.currencyId)), 1)
                    ]))
                  }), 128)),
                  ($setup.invoice.discountAmount > 0)
                    ? (_openBlock(), _createBlock("tr", _hoisted_22, [
                        _createVNode("td", _hoisted_23, [
                          _createVNode("div", null, _toDisplayString(_ctx.$t('accounting.productLine.discount')), 1)
                        ]),
                        _hoisted_24,
                        _hoisted_25,
                        _createVNode("td", _hoisted_26, " - " + _toDisplayString(_ctx.formatAmount($setup.invoice.discountAmount)) + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1),
                        _hoisted_27
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("table", _hoisted_29, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.itemDescription')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.qty')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.unit')), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                    ])
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.invoice.products, (product, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", _hoisted_30, [
                        _createVNode("div", null, _toDisplayString(product.name), 1),
                        _createVNode("span", null, _toDisplayString(product.unitName), 1)
                      ]),
                      _createVNode("td", _hoisted_31, _toDisplayString(product.quantity), 1),
                      _createVNode("td", _hoisted_32, _toDisplayString(_ctx.formatAmount(product.pricePerUnit)) + " " + _toDisplayString($setup.getCurrencySymbol(product.currencyId)), 1),
                      _createVNode("td", _hoisted_33, _toDisplayString(_ctx.formatAmount(product.total)) + " " + _toDisplayString($setup.getCurrencySymbol(product.currencyId)), 1)
                    ]))
                  }), 128)),
                  ($setup.invoice.discountAmount > 0)
                    ? (_openBlock(), _createBlock("tr", _hoisted_34, [
                        _createVNode("td", _hoisted_35, [
                          _createVNode("div", null, _toDisplayString(_ctx.$t('accounting.productLine.discount')), 1)
                        ]),
                        _hoisted_36,
                        _hoisted_37,
                        _createVNode("td", _hoisted_38, " - " + _toDisplayString(_ctx.formatAmount($setup.invoice.discountAmount)) + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('accounting.total')) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1),
                    _createVNode("div", _hoisted_45, _toDisplayString(_ctx.formatAmount($setup.invoice.productsTotalAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1)
                  ]),
                  _hoisted_46
                ])
              ]),
              _createVNode("div", _hoisted_47, [
                _createVNode("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, [
                        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('accounting.additional')), 1)
                      ]),
                      _createVNode("div", _hoisted_53, [
                        _createVNode("div", _hoisted_54, _toDisplayString(_ctx.formatAmount($setup.invoice.extraAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", _hoisted_56, _toDisplayString($setup.invoice.vatPercent) + "% " + _toDisplayString(_ctx.$t('accounting.vat')), 1),
                    _createVNode("div", _hoisted_57, _toDisplayString(_ctx.formatAmount($setup.invoice.vatAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1)
                  ]),
                  _hoisted_58
                ])
              ]),
              _createVNode("div", _hoisted_59, [
                _createVNode("div", _hoisted_60, [
                  _createVNode("div", _hoisted_61, [
                    _createVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('accounting.total')), 1),
                    _createVNode("div", _hoisted_63, _toDisplayString(_ctx.formatAmount($setup.invoice.totalAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)), 1)
                  ]),
                  _hoisted_64
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_65, " Total " + _toDisplayString(_ctx.formatAmount($setup.invoice.totalAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.invoice.currencyId)) + " (" + _toDisplayString($setup.invoice.products.length) + " products) ", 1),
    _createVNode("div", _hoisted_66, [
      _createVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.close())),
        class: "accounting-circle-button dark-circle-button"
      }, _toDisplayString(_ctx.$t('button.close')), 1),
      _createVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPdf())),
        class: "accounting-circle-button btn-blue"
      }, _toDisplayString(_ctx.$t('button.view-pdf')), 1),
      _hoisted_67
    ])
  ], 64))
})